import { ServerErrorMiddleware } from "./ServerErrorMiddleware";

/**
 * A middleware that handles 401 Unauthorized responses by setting a session expired flag
 * in sessionStorage and dispatching a global event.
 */
export class UnauthenticatedAwareServerErrorMiddleware
  implements ServerErrorMiddleware
{
  static UnauthenticatedEventType = "UnauthenticatedEvent";

  private readonly ignoredPaths: Array<string>;

  constructor(ignoredPaths?: Array<string>) {
    this.ignoredPaths = ignoredPaths ?? [];
  }

  public handle = (response: Response, request?: RequestInfo) => {
    if (request) {
      const url = typeof request === "string" ? request : request.url;
      if (this.ignoredPaths.some((path) => url.includes(path))) {
        return;
      }
    }

    if (response.status === 401) {
      if (typeof window !== "undefined") {
        window.dispatchEvent(
          new CustomEvent(
            UnauthenticatedAwareServerErrorMiddleware.UnauthenticatedEventType
          )
        );
      }
    }
  };
}
